var go = require('gojs');
var svgGeometry = require('./svgGeometry');

const $ = go.GraphObject.make;

function clearPanel(panel) {
  if (!panel) return;
  var toRemove = [];
  panel.elements.each(function(child) {
    toRemove.push(child);
  });
  toRemove.forEach(function(child) {
    panel.remove(child);
  });
}

function populatePanelWithSvg(panel, svgString) {
  if (!panel) return;
  clearPanel(panel);

  var sanitized = typeof svgString === 'string' ? svgString.trim() : '';
  if (!sanitized) return;

  try {
    var xmlDoc = new DOMParser().parseFromString(sanitized, 'image/svg+xml');
    if (!xmlDoc || !xmlDoc.documentElement) return;

    var root = xmlDoc.documentElement;
    var paths = root.querySelectorAll('path');
    var nonPathElements = Array.prototype.slice.call(root.querySelectorAll('*')).filter(function(element) {
      return element.tagName && element.tagName.toLowerCase() !== 'path';
    });

    if (nonPathElements.length > 0) {
      console.warn(
        '[svgPanelUtils] svgConverted contains non-path elements; skipping render.',
        nonPathElements.map(function(element) { return element.tagName; })
      );
      return;
    }

    if (!paths.length) return;

    paths.forEach(function(pathElement) {
      var data = pathElement.getAttribute('d');
      if (typeof data !== 'string' || data.trim().length === 0) {
        return;
      }

      var shape = new go.Shape();
      applyAttributes(shape, pathElement);

      var geometry = svgGeometry.parseSvgPathGeometry(data, {
        element: pathElement,
        context: 'svgPanelUtils'
      });
      if (!geometry) {
        return;
      }
      shape.geometry = geometry;

      var spotPanel = $(go.Panel, 'Spot');
      spotPanel.add(shape);
      panel.add(spotPanel);
    });
  } catch (err) {
    console.error('Failed to parse SVG string', err);
  }
}

function applyAttributes(shape, element) {
  if (!shape || !element) return;

  var id = element.getAttribute('id');
  if (typeof id === 'string') {
    shape.name = id;
  }

  var opacity = element.getAttribute('opacity');
  if (opacity !== null) {
    var parsedOpacity = parseFloat(opacity);
    if (!Number.isNaN(parsedOpacity)) {
      shape.opacity = clampOpacity(parsedOpacity);
    }
  }

  var fill = element.getAttribute('fill');
  if (typeof fill === 'string') {
    var normalizedFill = fill.trim();
    if (
      normalizedFill &&
      normalizedFill !== 'none' &&
      normalizedFill.toLowerCase() !== 'transparent' &&
      !normalizedFill.startsWith('url(')
    ) {
      shape.fill = applyOpacityToColor(
        normalizedFill,
        element.getAttribute('fill-opacity')
      );
    } else {
      shape.fill = null;
    }
  }

  var stroke = element.getAttribute('stroke');
  if (typeof stroke === 'string') {
    var normalizedStroke = stroke.trim();
    if (normalizedStroke && normalizedStroke !== 'none' && !normalizedStroke.startsWith('url(')) {
      shape.stroke = applyOpacityToColor(
        normalizedStroke,
        element.getAttribute('stroke-opacity')
      );
    } else {
      shape.stroke = null;
    }
  }

  var strokeWidth = parseFloat(element.getAttribute('stroke-width'));
  if (!Number.isNaN(strokeWidth)) {
    shape.strokeWidth = strokeWidth;
  }

  var strokeLinecap = element.getAttribute('stroke-linecap') || element.getAttribute('strokeLinecap');
  if (strokeLinecap) {
    shape.strokeCap = strokeLinecap;
  }

  var strokeLinejoin = element.getAttribute('stroke-linejoin') || element.getAttribute('strokeLinejoin');
  if (strokeLinejoin) {
    shape.strokeJoin = strokeLinejoin;
  }

  var strokeMiterlimit = parseFloat(element.getAttribute('stroke-miterlimit'));
  if (!Number.isNaN(strokeMiterlimit)) {
    shape.strokeMiterLimit = strokeMiterlimit;
  }

  var dashArray = element.getAttribute('stroke-dasharray');
  if (dashArray && dashArray.toLowerCase() !== 'none') {
    var dashValues = dashArray.split(/[\s,]+/).map(function(part) {
      var value = parseFloat(part);
      return Number.isFinite(value) ? value : null;
    }).filter(function(value) {
      return value !== null;
    });
    if (dashValues.length > 0) {
      shape.strokeDashArray = dashValues;
    }
  }

  var dashOffset = parseFloat(element.getAttribute('stroke-dashoffset'));
  if (!Number.isNaN(dashOffset)) {
    shape.strokeDashOffset = dashOffset;
  }
}

function applyOpacityToColor(color, opacityAttribute) {
  if (!color || typeof color !== 'string') return color;
  if (opacityAttribute === null || opacityAttribute === undefined) {
    return color;
  }

  var opacity = parseFloat(opacityAttribute);
  if (Number.isNaN(opacity)) return color;

  var clamped = clampOpacity(opacity);
  if (/^rgba?\(/i.test(color)) {
    var rgbaMatch = color.match(/rgba?\(([^)]+)\)/i);
    if (rgbaMatch && rgbaMatch[1]) {
      var parts = rgbaMatch[1].split(',').map(function(value) { return value.trim(); });
      if (parts.length >= 3) {
        return 'rgba(' + parts[0] + ', ' + parts[1] + ', ' + parts[2] + ', ' + clamped + ')';
      }
    }
    return color;
  }

  if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(color)) {
    var hex = color.slice(1);
    if (hex.length === 3) {
      hex = hex.split('').map(function(ch) { return ch + ch; }).join('');
    }
    var intVal = parseInt(hex, 16);
    var r = (intVal >> 16) & 255;
    var g = (intVal >> 8) & 255;
    var b = intVal & 255;
    return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + clamped + ')';
  }

  return color;
}

function clampOpacity(value) {
  if (!Number.isFinite(value)) return 1;
  if (value < 0) return 0;
  if (value > 1) return 1;
  return value;
}

module.exports = {
  populatePanelWithSvg,
  clearPanel
};
